import React from 'react';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { Spinner } from '@xometry/xometry_loft';

import { STATSIG_CLIENT_KEY, STATSIG_ENV } from '../config';

type XomStatsigProps = {
  userId?: string;
  partnerId?: string;
  children: React.ReactNode;
};

export const XomStatsigProvider = ({
  userId,
  partnerId,
  children,
}: XomStatsigProps): JSX.Element => {
  const { client, isLoading } = useClientAsyncInit(
    STATSIG_CLIENT_KEY,
    {
      userID: userId,
      custom: {
        partnerID: partnerId,
      },
    },
    {
      environment: { tier: STATSIG_ENV || 'stage' },
    }
  );

  if (isLoading) {
    return (
      <div className="flex width-fit mar-0 mar-r-auto mar-l-auto">
        <Spinner />
      </div>
    );
  }

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
